import { useApi } from "shared/services/api/useApi";

export const useClients = () => {
    const { getDataAsync } = useApi();

    const getClientsFilter = async (params) => {
        const payload = await getDataAsync("clientsFilter", { params: params });
        return payload.json();
    };

    return { getClientsFilter };
};
